import React from "react";
import { useTranslation } from "react-i18next";
import Skills from "./Skills/Skills";

const About = () => {
  const { t } = useTranslation();

  return (
    <section>
      <h3 className="text-2xl md:text-3xl font-semibold text-text mb-4">{t("about.title")}</h3>
      <p className="text-[1.0625rem] leading-[1.7] text-prose md:text-lg md:leading-[1.75]">
        {t("about.description")}
      </p>
      <Skills />
    </section>
  );
};

export default About;
